//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavProjects(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 13H17V15C17 16.1046 16.1046 17 15 17H13V13Z" fill="currentColor" /><path d="M7 13H11V17H9C7.89543 17 7 16.1046 7 15V13Z" fill="currentColor" /><path d="M13 7H15C16.1046 7 17 7.89543 17 9V11H13V7Z" fill="currentColor" /><path d="M7 9C7 7.89543 7.89543 7 9 7H11V11H7V9Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M2 4V18H4V4H20V20H2V22H20H22V20V4V2H20H4H2V4Z" fill="currentColor" /></svg>;
}
export default IconNavProjects;